import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LanguageContext";
import { api, formatApiError } from "../lib/api";
import Layout from "../components/Layout";
import { Check, ArrowUpRight } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1491911923017-19f90d8d7f83?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setLoading(false); }
  };

  return (
    <Layout noFooter>
      <section className="relative min-h-screen flex">
        <div className="hidden md:block w-1/2 relative">
          <img src={BG} alt="" className="absolute inset-0 w-full h-full object-cover editorial-img" />
          <div className="absolute inset-0 bg-navy/55"></div>
        </div>
        <div className="flex-1 flex items-center justify-center px-6 md:px-12 py-32">
          <div className="w-full max-w-md">
            <h1 className="font-serif text-4xl md:text-5xl font-light text-navy leading-tight mb-3">{t.auth.forgot_title}</h1>
            <p className="text-ink/60 mb-10">{t.auth.forgot_sub}</p>

            {done ? (
              <div data-testid="forgot-done" className="flex items-start gap-3 p-5 bg-brand/10 border border-brand/30">
                <Check size={18} className="text-brand mt-0.5" />
                <span className="text-sm text-ink">{t.auth.forgot_done}</span>
              </div>
            ) : (
              <form onSubmit={submit} data-testid="forgot-form" className="space-y-7">
                <div>
                  <label className="block text-[10px] uppercase tracking-[0.25em] font-mono text-ink/55 mb-2">{t.auth.email}</label>
                  <input data-testid="forgot-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-ink/20 py-2 focus:outline-none focus:border-brand transition-colors" />
                </div>
                {err && <div className="text-sm text-destructive">{err}</div>}
                <button data-testid="forgot-submit" disabled={loading} type="submit" className="w-full bg-brand hover:bg-brandDark disabled:opacity-60 text-white py-4 text-sm uppercase tracking-[0.18em] font-mono inline-flex items-center justify-center gap-3">
                  {loading ? "..." : t.auth.forgot_submit} <ArrowUpRight size={16} />
                </button>
              </form>
            )}

            <div className="mt-12 pt-8 border-t border-black/10 text-xs text-ink/50">
              <Link to="/login" className="link-underline">← {t.auth.back}</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
